
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface ProjectListHeaderProps {
  activeTemplateName: string | null;
  startDate: string;
  endDate: string;
  duration: number;
  onNewProjectClick: () => void;
  onCustomProjectClick: () => void;
  isRestrictedUser?: boolean;
}

export const ProjectListHeader = ({ 
  activeTemplateName, 
  startDate, 
  endDate, 
  duration,
  onNewProjectClick,
  onCustomProjectClick,
  isRestrictedUser = false
}: ProjectListHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <div>
        <h2 className="text-xl text-white font-semibold">Select Project</h2>
        <p className="text-sm text-gray-400">Select a project to load the project parameters in the other tabs</p>
      </div>
      
      <div className="flex gap-2">
        <Button
          onClick={onCustomProjectClick}
          disabled={isRestrictedUser}
          className={`${
            isRestrictedUser 
              ? "bg-gray-600 text-gray-400 cursor-not-allowed hover:bg-gray-600" 
              : "bg-primary text-black hover:bg-primary/90"
          }`}
        >
          <Plus className="mr-2 h-4 w-4" />
          Add Custom Project
        </Button>
      </div>
    </div>
  );
};
